import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/integrations')({
  head: () => ({
    meta: [{ title: 'Integrations | Tekst' }],
  }),
  component: () => <Outlet />,
});
